import { useQuery } from "@tanstack/react-query";
import { getShippingRegions } from "../services/shippingService";

const useShippingRegions = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["shippingRegions"],
    queryFn: async () => {
      const response = await getShippingRegions();
      return response;
    },
    select: (response) => response.message || [],
  });

  return {
    regions: data || [],
    loading: isLoading,
    error: error?.message || null,
  };
};

export default useShippingRegions;
